module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon6.36b374c1.svg";